import { Fragment } from 'react';
import { Group, Title, Text, Breadcrumbs, Anchor } from '@mantine/core';
import { Link } from 'react-router-dom';

export interface PageHeaderBreadcrumb {
  label: string;
  to?: string;
}

interface PageHeaderProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
  breadcrumbs?: PageHeaderBreadcrumb[];
}

export function PageHeader({ title, description, children, breadcrumbs }: PageHeaderProps) {
  return (
    <Fragment>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Breadcrumbs mb="xs" separator="/">
          {breadcrumbs.map((crumb, index) =>
            crumb.to ? (
              <Anchor key={index} component={Link} to={crumb.to} size="sm" color="dimmed">
                {crumb.label}
              </Anchor>
            ) : (
              <Text key={index} size="sm" color="dimmed">
                {crumb.label}
              </Text>
            )
          )}
        </Breadcrumbs>
      )}
      <Group
        position="apart"
        mb="lg"
        sx={(theme) => ({
          [theme.fn.smallerThan('sm')]: {
            flexDirection: 'column',
            alignItems: 'stretch',
          },
        })}
      >
        <div>
          <Title
            order={2}
            sx={(theme) => ({
              color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : '#1b1b1b',
              fontWeight: 600,
            })}
          >
            {title}
          </Title>
          {description && (
            <Text color="dimmed" size="sm">
              {description}
            </Text>
          )}
        </div>
        {children}
      </Group>
    </Fragment>
  );
}

